import isArray from 'lodash/isArray';
export const getPlainName = (name)=>{
    if (!name) {
        return '';
    }
    if (isArray(name)) {
        return name.join(' ').trim();
    }
    return name.trim();
};
export const getHslColor = (name)=>{
    const plainName = getPlainName(name);
    if (!plainName) {
        return null;
    }
    let hash = 0;
    for(let i = 0; i < plainName.length; i++){
        hash = plainName.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    return `hsl(${h}, 70%, 80%)`;
};
